import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { OhVueIcon, addIcons } from 'oh-vue-icons';
import {
  FaInfoCircle,
  FaLink,
  FaCheckCircle,
  FaTimesCircle,
  FaTrash,
  FaExclamationCircle,
  FaTimes,
  CoPlus,
  FaGamepad,
  CoHome,
  GiSoapExperiment,
  OiGear,
  HiLogout,
  MdCancelTwotone,
  GiConfirmed,
  FaCopy,
  FaClipboard,
  FaDiscord,
  PrSpinner,
} from 'oh-vue-icons/icons';

import App from './App.vue';
import { createRouter } from './router';

import './assets/main.css';

addIcons(
  FaTrash,
  FaLink,
  FaInfoCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationCircle,
  FaTimes,
  FaGamepad,
  CoPlus,
  CoHome,
  GiSoapExperiment,
  OiGear,
  HiLogout,
  MdCancelTwotone,
  GiConfirmed,
  FaCopy,
  FaClipboard,
  FaDiscord,
  PrSpinner,
);

const app = createApp(App);

app.use(createPinia());
app.use(createRouter());

app.component('v-icon', OhVueIcon);

app.mount('#app');
